import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

type ScheduleConflictDialogProps = {
    isOpen: boolean;
    conflictCount: number;
    onConfirm: () => void;
    onCancel: () => void;
};

export const ScheduleConflictDialog = ({ isOpen, conflictCount, onConfirm, onCancel }: ScheduleConflictDialogProps) => {
    return (
        <Dialog
            open={isOpen}
            onClose={onCancel}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                },
            }}
        >
            <DialogTitle sx={{ textAlign: "center", pt: 4 }}>
                <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                    <WarningAmberIcon sx={{ fontSize: 64, color: "error.main" }} />
                </Box>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                    Atenção
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ textAlign: "center", pb: 2 }}>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Este cliente já tem agendado <strong>{conflictCount}</strong>{" "}
                    {conflictCount === 1 ? "fatura" : "faturas"} para essa semana.
                </Typography>
                <Typography variant="body1" sx={{ color: "text.secondary" }}>
                    De certeza que quer marcar mais uma para esta semana?
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center", pb: 3, gap: 2 }}>
                <Button onClick={onCancel} variant="outlined" color="secondary" size="large">
                    Cancelar
                </Button>
                <Button onClick={onConfirm} variant="contained" color="primary" size="large">
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

